import React from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import cx from "classnames";
import dateFormat from "dateformat";
import styles from "./learners.module.scss";
import Thumbnail from "src/components/thumbnail";

export const CoursesLearnersList: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id as string;
  const learningId = params.learningId as string;

  const learners = useSelector((state: any) => state.courses.learners.items || []);

  const completedLearners = learners.filter((item: any) => item.status === "COMPLETED");

  const handleSelectLearner = (learner: any) => {
    navigate(`/coaching/manage/courses/${id}/reports/${learner.id}`);
  };

  return (
    <div className={styles.learnersList}>
      {completedLearners.map((item: any) => (
        <div
          key={item.id}
          className={styles.learner}
          onClick={() => handleSelectLearner(item)}
        >
          <div
            className={cx(styles.left, {
              [styles.active]: item.id === learningId,
            })}
          >
            <div className={styles.details}>
              <Thumbnail
                media={item.user?.icon}
                defaultImage="/images/assets/default_asset.jpg"
                className={styles.icon}
              />
              <div className={styles.info}>
                <span className={styles.name}>
                  {item.user.firstName || ""} {item.user.lastName}
                  {item.status === "COMPLETED" && (
                    <i className="paperflite-flag" />
                  )}
                </span>
                <span className={styles.engagedDate}>
                  last completed on{" "}
                  {dateFormat(item.modifiedDate, "dd mmm yyyy")}
                </span>
              </div>
            </div>
          </div>
          <div className={styles.progress}>
            {item.score ? `${Math.round(item.score * 100)} %` : "na"}
          </div>
        </div>
      ))}
    </div>
  );
};
